import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import NrCrew from "../../components/NrCrew";
import NrAnglers from "../../components/NrAnglers";
import TripType from "../../components/TripType";
import VesselOperator from "../../components/VesselOperator";
import {
  getCurrentOpenTrip,
  getDisplayTripType,
  getShowAnglerField,
  getShowCrewField,
  getReportTripTypeKey,
  getTripValuesByKey,
  getOperatorOptions,
} from "../../constants/vtrTrip";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import TripReviewRedirect from "../../components/TripReviewRedirect";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import Spinner from "../../components/common/Spinner";
import { validateTripSet1 } from "../../constants/tripValidations";
import Grid from "@mui/material/Grid";
import { success } from "../../constants/colors";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

function TripTypePage(props) {
  useScrollToTop();

  const { actions } = props;
  const { auth, vtrTrip, helpText, validation } = useSelector((state) => state);
  const [values, setValues] = useState({
    currentType: "",
    report_type: 1,
    trip_type: "",
    display_trip_type: "",
    number_of_crew: "",
    number_of_anglers: "",
    showNrCrewField: false,
    showNrAnglersField: false,
    isLoaded: false,
    default_uom: "",
    default_species_uom: "",
    operator_ext_name: "",
    operator_first_name: "",
    operator_middle_name: "",
    operator_last_name: "",
    operator_options: "",
    operator_permit_number: "",
  });
  const location = useLocation();

  const handleTripTypeChange = (event, value) => {
    event.preventDefault();
    const { reportTripType } = validation.validations;
    const tripValues = getTripValuesByKey(value, reportTripType);
    const newDisplayTripType = getDisplayTripType(
      tripValues.REPORT_TYPE,
      tripValues.TRIP_TYPE,
      reportTripType
    );
    const showNrCrew = getShowCrewField(tripValues.TRIP_TYPE);
    const showNrAnglers = getShowAnglerField(tripValues.TRIP_TYPE);

    let newState = {};
    newState.currentType = value;
    newState.report_type = tripValues.REPORT_TYPE;
    newState.trip_type = tripValues.TRIP_TYPE;
    newState.display_trip_type = newDisplayTripType;
    newState.default_uom = tripValues.DEFAULT_UOM;
    newState.default_species_uom = tripValues.DEFAULT_SPECIES_UOM;
    newState.showNrCrewField = showNrCrew;
    newState.showNrAnglersField = showNrAnglers;
    // * In case the user chose a trip type that doesn't required
    // * one of the following fields.
    newState.number_of_crew = showNrCrew ? values.number_of_crew : "";
    newState.number_of_anglers = showNrAnglers ? values.number_of_anglers : "";
    setValues({ ...values, ...newState });
  };

  const handleTripPreferenceChange = (event) => {
    event.preventDefault();
    const { newValue, field } = event.currentTarget.dataset;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }

    setValues({ ...values, [field]: newValue });
  };

  const handleOperatorChange = (event, reason) => {
    event.preventDefault();
    if (reason) {
      setValues({
        ...values,
        operator_first_name: reason.NAME_FIRST,
        operator_middle_name: reason.NAME_MIDDLE,
        operator_last_name: reason.NAME_LAST,
        operator_permit_number: reason.OPERATOR_KEY,
        operator_ext_name: reason.hasOwnProperty("NAME_EXT")
          ? reason.NAME_EXT
          : "",
      });
    } else {
      setValues({
        ...values,
        operator_ext_name: "",
        operator_first_name: "",
        operator_middle_name: "",
        operator_last_name: "",
        operator_permit_number: "",
      });
    }
  };

  const handleOperatorPreferenceChange = (event) => {
    event.preventDefault();
    const { nameFirst, nameLast, nameMiddle, operatorKey, nameExt } =
      event.currentTarget.dataset;
    setValues({
      ...values,
      operator_ext_name: nameExt,
      operator_first_name: nameFirst,
      operator_middle_name: nameMiddle,
      operator_last_name: nameLast,
      operator_permit_number: operatorKey,
    });
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    actions.setError([]);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    let allErrors = [];
    allErrors = validateTripSet1(values);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      return;
    }
    if (value === "Save") {
      actions.updateTrip(values, auth.client_id, location.state.trip_id);
    }
  };

  useEffect(() => {
    if (values.isLoaded === false) {
      const tripId = location.state.trip_id;
      const allOpenTrips = vtrTrip.allOpenTrips;
      const currentTrip = getCurrentOpenTrip(allOpenTrips, tripId);
      let newState = {};
      newState.isLoaded = true;
      if (currentTrip && currentTrip.report_type && currentTrip.trip_type) {
        const currentType = getReportTripTypeKey(
          currentTrip.report_type,
          currentTrip.trip_type,
          validation.validations.reportTripType
        );
        const displayTripType = getDisplayTripType(
          currentTrip.report_type,
          currentTrip.trip_type,
          validation.validations.reportTripType
        );
        const showNrCrew = getShowCrewField(currentTrip.trip_type);
        const showNrAnglers = getShowAnglerField(currentTrip.trip_type);

        const operatorOptions = getOperatorOptions(
          validation.validations.operator,
          auth.vessel_entitlements,
          auth.operator_entitlements,
          auth,
          currentTrip.vessel_permit_num
        );
        newState.currentType = currentType;
        newState.report_type = String(currentTrip.report_type);
        newState.trip_type = String(currentTrip.trip_type);
        newState.default_uom = currentTrip.default_uom;
        newState.default_species_uom = currentTrip.default_species_uom;
        newState.display_trip_type = displayTripType;
        newState.number_of_crew = currentTrip.number_of_crew;
        newState.number_of_anglers = currentTrip.number_of_anglers;
        newState.showNrCrewField = showNrCrew;
        newState.showNrAnglersField = showNrAnglers;
        newState.operator_permit_number = currentTrip.operator_permit_number;
        newState.operator_ext_name = currentTrip.operator_ext_name;
        newState.operator_first_name = currentTrip.operator_first_name;
        newState.operator_last_name = currentTrip.operator_last_name;
        newState.operator_middle_name = currentTrip.operator_middle_name;
        newState.operator_options = operatorOptions;
      }
      setValues({ ...values, ...newState });
    }
  }, [
    auth,
    location.state.trip_id,
    validation.validations.operator,
    validation.validations.reportTripType,
    values,
    vtrTrip.allOpenTrips,
  ]);

  if (vtrTrip.redirect === true) {
    return (
      <TripReviewRedirect
        trip_id={location.state.trip_id}
        client_id={auth.client_id}
      />
    );
  }

  if (values.isLoaded === false) {
    return <Spinner />;
  }

  return (
    <div className="trip-form-container">
      <TripType
        preferences={auth.vtr_preferences.trip}
        currentType={values.currentType}
        types={validation.validations.reportTripType}
        handleChange={handleTripTypeChange}
        handleTripTypePreferenceChange={handleTripTypeChange}
        helpText={helpText.helpText}
      />
      {values.showNrCrewField && (
        <NrCrew
          handleInputChange={handleInputChange}
          number_of_crew={values.number_of_crew}
          preferences={auth.vtr_preferences.trip}
          trip_type={values.trip_type}
          handleTripPreferenceChange={handleTripPreferenceChange}
          helpText={helpText.helpText}
        />
      )}
      {values.showNrAnglersField && (
        <NrAnglers
          handleInputChange={handleInputChange}
          number_of_anglers={values.number_of_anglers}
          preferences={auth.vtr_preferences.trip}
          trip_type={values.trip_type}
          handleTripPreferenceChange={handleTripPreferenceChange}
          helpText={helpText.helpText}
        />
      )}
      <VesselOperator
        changeHandler={handleOperatorChange}
        operatorOptions={values.operator_options}
        operator_permit_number={values.operator_permit_number}
        operator_first_name={values.operator_first_name}
        operator_middle_name={values.operator_middle_name}
        operator_last_name={values.operator_last_name}
        operator_ext_name={values.operator_ext_name}
        handleTripOperatorPreferenceChange={handleOperatorPreferenceChange}
        preferences={auth.vtr_preferences.operator}
        helpText={helpText.helpText}
      />
      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(TripTypePage);
